import { createRouter, createWebHistory } from 'vue-router'
import CreateAnalysis from '@page/CreateAnalysis.vue'
import Fail from '@page/Fail.vue'
import Home from '@page/Home.vue'
import Login from '@page/Login.vue'
import ResultsDashboard from '@page/ResultsDashboard.vue'
import User from '@page/User.vue'
import { useIndexStore } from '@src/store'
import { checkAuth } from '@src/utils/auth'

// only used to force to see translation to vue-gettext
const $gettext = s => s

// Auth pages start
export const ifAuthenticated = async (to, _from) => {
  const user = await checkAuth()
  if (user) {
    useIndexStore().changeUser(user)
    return null
  } else {
    return to.name != 'Login' ? { name: 'Login' } : false
  }
}
export const loginRoute = {
  path: '/login',
  name: 'Login',
  component: Login,
}
export const failRoute = {
  path: '/fail',
  name: 'Fail',
  component: Fail,
}
export const userRoute = {
  path: '/user',
  name: 'User',
  component: User,
  beforeEnter: ifAuthenticated,
}
export const disconnectRoute = { /* no path, no component, just a link in the menu */
  name: 'Disconnect',
  icon: 'fas fa-sign-out-alt',
  title: $gettext('Logout'),
}
// Auth pages end
export const homeRoute = {
  path: '/',
  name: 'Home',
  component: Home,
  icon: 'fas fa-house',
  title: $gettext('Home'),
  beforeEnter: ifAuthenticated,
}
export const createAnalysisRoute = {
  path: '/create-analysis',
  name: 'CreateAnalysis',
  component: CreateAnalysis,
  icon: 'fas fa-search-location',
  title: $gettext('Create analysis'),
  beforeEnter: ifAuthenticated,
}
export const resultsRoute = {
  path: '/results',
  name: 'ResultsDashboard',
  component: ResultsDashboard,
  icon: 'fas fa-layer-group',
  title: $gettext('Results dashboard'),
  beforeEnter: ifAuthenticated,
}
export const routes = [
  homeRoute,
  loginRoute,
  failRoute,
  userRoute,
  createAnalysisRoute,
  resultsRoute,
]
export const fullscreenRoutes = [
  loginRoute,
  failRoute,
]
export const navigationRoutes = [
  homeRoute,
  createAnalysisRoute,
  resultsRoute,
  disconnectRoute,
]
export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})
